import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState } from '../../../../types/types';
import { IRestChat } from 'app/types/rest/IRestChat';
import { updateAction as cUpdateAction } from '../../../../view/react_components/main/chatView/store/chat/actions/updateAction';
import { updateAction as gUpdateAction } from '../../../../view/react_components/main/chatView/store/chatGroup/actions/updateAction';
import { ICards } from 'app/store/model/cards/types';
import { cardsUpdate } from 'app/store/model/actionCreators/cardsUpdate';
import { chatGroupUpdateAction } from 'app/view/react_components/main/chatView/store/chatView/actions/chatGroupUpdateAction';
import { chatUpdateAction } from 'app/view/react_components/main/chatView/store/chatView/actions/chatUpdateAction';
import { sendAuthUserRealTimeStoreAction } from 'app/view/react_components/base/helpers/realTimeHelperTS';

//TODO done
/***
 * Обновляем стор
 * @param chat
 * @param isRealtime
 */
export const updateStoreChat = (
    chat: IRestChat,
    isRealtime: boolean = false
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (chat.boardChatGroup){
            let chatGroup = chat.boardChatGroup;
            let action  = chatGroupUpdateAction(chatGroup.id, gUpdateAction(chatGroup));
            if (isRealtime) {
                dispatch(sendAuthUserRealTimeStoreAction(action));
            }
            dispatch(action);
            delete chat.boardChatGroup;
        }
        let action = chatUpdateAction(chat.id, cUpdateAction(chat));
        if (isRealtime) {
            dispatch(sendAuthUserRealTimeStoreAction(action));
        }
        dispatch(action);

        const cards: ICards = {
            [chat.cardId]: {
                chatId: chat.id
            }
        };
        dispatch(cardsUpdate(cards));
        if (isRealtime) {
            dispatch(sendAuthUserRealTimeStoreAction(cardsUpdate(cards)));
        }
        return chat;
    };
    return action;
};
